import React from "react";
import { RadioGroupField } from "@aws-amplify/ui-react";

const StatelessRadioGroupField = ({ children, ...props }) => {
    return (
        <RadioGroupField key={props.key}
            value={props.value}
            onChange={(e) => props.handleChange(e)}
            name={props.Name + '_' + props.index} id={props.Name + '_' + props.index}
            labelPosition="end"
        >{children}</RadioGroupField>
    )
}

export default StatelessRadioGroupField;